import { render, staticRenderFns } from "./AppAnnotationPart6.vue?vue&type=template&id=7415d710&scoped=true"
import script from "./AppAnnotationPart6.vue?vue&type=script&lang=ts"
export * from "./AppAnnotationPart6.vue?vue&type=script&lang=ts"
import style0 from "./AppAnnotationPart6.vue?vue&type=style&index=0&id=7415d710&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7415d710",
  null
  
)

export default component.exports